import {
  ComplianceEnum,
  IntegrationEnum,
  LocalizationEnum,
  type Compliance,
  type Integration,
  type Localization,
} from '@flashpoint/site-dna';
import type { StepProps } from '../stepProps';

export function ContextStep({ lead, queueField }: StepProps) {
  const ctx = lead.context;

  const toggleIntegration = (opt: Integration) => {
    const set = new Set<Integration>(ctx.integrations);
    if (set.has(opt)) set.delete(opt);
    else set.add(opt);
    queueField('context.integrations', Array.from(set));
  };

  const toggleCompliance = (opt: Compliance) => {
    const set = new Set<Compliance>(ctx.compliance);
    if (set.has(opt)) set.delete(opt);
    else set.add(opt);
    queueField('context.compliance', Array.from(set));
  };

  return (
    <div className="space-y-6">
      <section>
        <Label>Integrations needed</Label>
        <div className="flex flex-wrap gap-2">
          {IntegrationEnum.options.map((opt) => {
            const selected = ctx.integrations.includes(opt as Integration);
            return (
              <button
                key={opt}
                type="button"
                onClick={() => toggleIntegration(opt as Integration)}
                className={`rounded-full px-3 py-1.5 text-sm font-medium transition ${
                  selected
                    ? 'bg-flashpoint-spark text-nm-on-accent'
                    : 'border border-nm-border text-nm-ink hover:border-nm-accent'
                }`}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </section>

      <section>
        <Label>Compliance targets</Label>
        <div className="flex flex-wrap gap-2">
          {ComplianceEnum.options.map((opt) => {
            const selected = ctx.compliance.includes(opt as Compliance);
            return (
              <button
                key={opt}
                type="button"
                onClick={() => toggleCompliance(opt as Compliance)}
                className={`rounded-full px-3 py-1.5 text-sm font-medium transition ${
                  selected
                    ? 'bg-flashpoint-ember text-nm-ink'
                    : 'border border-nm-border text-nm-ink hover:border-nm-accent'
                }`}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </section>

      <section>
        <Label>Localization</Label>
        <div className="flex flex-wrap gap-2">
          {LocalizationEnum.options.map((opt) => {
            const selected = ctx.localization === opt;
            return (
              <button
                key={opt}
                type="button"
                onClick={() => queueField('context.localization', opt as Localization)}
                className={`rounded-full px-3 py-1.5 text-sm font-medium transition ${
                  selected
                    ? 'bg-flashpoint-spark text-nm-on-accent'
                    : 'border border-nm-border text-nm-ink hover:border-nm-accent'
                }`}
              >
                {opt}
              </button>
            );
          })}
        </div>
      </section>
    </div>
  );
}

function Label({ children }: { children: React.ReactNode }) {
  return <div className="mb-2 text-[11px] uppercase tracking-widest text-nm-muted">{children}</div>;
}
